import axios from 'axios'
import { loading, loginApp } from 'common/js/common'

let timer = null

/* Global axios defaults */
axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.validateStatus = (status) => {
//   return status >= 200;
// }

/* Interceptors */
const reqInterceptor = config => {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    loading(true)
  }, 300)
  return config
}
const reqErr = err => {
  return Promise.reject(err)
}
const repInterceptor = res => {
  if (timer) clearTimeout(timer)
  loading(false)
  if (res.data && (res.data.data == -1 || res.data.code === 401)) {
    loginApp()
    return
  }
  return res
}
const repErr = err => {
  if (timer) clearTimeout(timer)
  loading(false)
  if (err && err.response && err.response.status === 401) {
    loginApp()
    return
  }
  return Promise.reject(err)
}

export { axios, reqInterceptor, reqErr, repInterceptor, repErr }
